'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _urlRegex = require('url-regex');

var _urlRegex2 = _interopRequireDefault(_urlRegex);

var _prependHttp = require('prepend-http');

var _prependHttp2 = _interopRequireDefault(_prependHttp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  isUrl: function isUrl(text) {
    return (0, _urlRegex2.default)().test(text);
  },
  normalizeUrl: function normalizeUrl(url) {
    return (0, _prependHttp2.default)(url);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-anchor-plugin/lib/utils/URLUtils.js
// module id = 1743
// module chunks = 0